import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import axios from "axios";
export default {
  props: {
    classes: {
      type: Array,
      default: () => []
    },
    allStudents: {
      type: Array,
      default: () => []
    },
    initialClassId: {
      type: [Number, String],
      required: true
    },
    institution: {
      type: String,
      required: true
    }
  },
  emits: ["close"],
  data() {
    return {
      classId: this.initialClassId,
      students: [],
      keyword: "",
      loading: false,
      editingId: null,
      remarkDraft: ""
    };
  },
  computed: {
    filteredStudents() {
      const key = this.keyword.toLowerCase();
      if (!key) return this.students;
      return this.students.filter(student => [student.name, student.phone, student.parentPhone, ...this.parsePhones(student.parentPhones)].filter(Boolean).some(value => String(value).toLowerCase().includes(key)));
    }
  },
  mounted() {
    this.loadStudents();
  },
  methods: {
    normalizeIds(value) {
      if (Array.isArray(value)) return value.map(String);
      try {
        const ids = JSON.parse(value || "[]");
        return Array.isArray(ids) ? ids.map(String) : [];
      } catch {
        return [];
      }
    },
    localStudents() {
      const classItem = this.classes.find(item => String(item.id) === String(this.classId)) || {};
      const enrolledIds = this.normalizeIds(classItem.studentIds);
      const mountedIds = this.normalizeIds(classItem.mountStudentIds);
      const ids = new Set([...enrolledIds, ...mountedIds]);
      return this.allStudents.filter(student => ids.has(String(student.id))).map(student => ({
        ...student,
        isEnrolled: enrolledIds.includes(String(student.id)),
        isMounted: mountedIds.includes(String(student.id)),
        remark: ""
      }));
    },
    parsePhones(value) {
      try {
        const phones = typeof value === "string" ? JSON.parse(value) : value;
        return Array.isArray(phones) ? phones : [];
      } catch {
        return [];
      }
    },
    phoneText(student) {
      return [student.phone, ...this.parsePhones(student.parentPhones), student.parentPhone].filter(Boolean).filter((value, index, arr) => arr.indexOf(value) === index).join(" / ") || "未填写电话";
    },
    async loadStudents() {
      this.loading = true;
      this.editingId = null;
      const localStudents = this.localStudents();
      this.students = localStudents;
      try {
        const response = await axios.post("https://backend.wonology.com/courseArrange/studentSchedule/getClassStudents", {
          classId: this.classId,
          institution: this.institution
        });
        if (response.data.code !== "0000") return;
        const serverStudents = Array.isArray(response.data.data) ? response.data.data : [];
        const ids = [...new Set([...localStudents, ...serverStudents].map(item => String(item.id)))];
        this.students = ids.map(id => {
          const local = localStudents.find(item => String(item.id) === id) || {};
          const serverStudent = serverStudents.find(item => String(item.id) === id) || {};
          return {
            ...local,
            ...serverStudent,
            phone: serverStudent.phone || local.phone,
            parentPhone: serverStudent.parentPhone || local.parentPhone,
            parentPhones: serverStudent.parentPhones || local.parentPhones,
            grade: serverStudent.grade || local.grade,
            school: serverStudent.school || local.school
          };
        });
      } catch (error) {
        console.log("班级详情接口尚不可用，使用页面学生资料：", error);
      } finally {
        this.loading = false;
      }
    },
    toggleEdit(student) {
      this.editingId = student.id;
      this.remarkDraft = student.remark || "";
    },
    cancelEdit() {
      this.editingId = null;
      this.remarkDraft = "";
    },
    async saveRemark(student) {
      try {
        const response = await axios.post("https://backend.wonology.com/courseArrange/studentSchedule/saveClassStudentRemark", {
          classId: this.classId,
          studentId: student.id,
          institution: this.institution,
          remark: this.remarkDraft
        });
        if (response.data.code !== "0000") return alert("保存备注失败：" + response.data.msg);
        student.remark = this.remarkDraft;
        this.cancelEdit();
      } catch (error) {
        alert("保存备注失败：" + error);
      }
    }
  }
};